import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchDistributorSuggestions = createAsyncThunk("fetchDistributorSuggestions", async ({ code, page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 50,
        status: filters?.status || "",
        dateFrom: filters?.dateFrom || "",
        dateTo: filters?.dateTo || "",
    });

    const response = await axiosHttp.get(`replenishment/distributors/${code}/suggestions?${params}`);
    return response.data;
});

const DistributorSuggestionsSlice = createSlice({
    name: "DistributorSuggestionsSlice",
    initialState: {
        isLoading: false,
        data: [],
        summary: {},
        error: null,
        total: 0,
        page: 1,
        limit: 50,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchDistributorSuggestions.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchDistributorSuggestions.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);
            state.summary = payload?.summary || {};

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 50)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchDistributorSuggestions.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default DistributorSuggestionsSlice.reducer;
